if(document.querySelector('.cover')) {
  
  const cover = document.querySelector('.cover');
  
  document.addEventListener('DOMContentLoaded', (e) => {
    setTimeout(() => {
      cover.classList.add('hidden');
    }, 3000);
  })
}

if (document.querySelectorAll('.number-animate').length > 0) {
  const observer = new IntersectionObserver(handleIntersection);
  const counters = document.querySelectorAll('.number-animate');
  const speed = 200;
  
  counters.forEach( counter => {
    observer.observe(counter);  
  });

  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        const animate = () => {
          const value = +entry.target.getAttribute('number').replace(/[, ]+/g, "");
          const data = +entry.target.innerText;
          const time = value / speed;
          if(data < value) {
            entry.target.innerText = Math.ceil(data + time);
              setTimeout(animate, 1);
            }else{
              entry.target.innerText = value.toLocaleString('fr-FR');
            }        
        }   
        animate();
      } 
    });
  }
}